export default "__VITE_ASSET__Ee9mjihy__"